export default __webpack_public_path__ + "static/media/Screenshot_4.b0097d64.png";